import { noConditionData } from '@Components/RiskDetails/RiskDetails.component';
import { Pagination, StylovyzeHeader } from '@innovyze/lib_am_common';

import { paginationInitialState } from '@innovyze/lib_am_common/Reducers';
import { TFunc } from '@Translations/types';
import { RiskDetailsRow } from '@Types/riskConfig.types';

// Columns in order displayed by table
export enum Column {
	AssetId = 0,
	RiskTrend,
	CurrentRisk,
	CurrentLOF,
	CurrentCOF,
	ConditionData,
	Grade,
}

export enum ColumnNoCD {
	AssetId = 0,
	RiskTrend,
	CurrentRisk,
	CurrentLOF,
	CurrentCOF,
	Grade,
}

export enum ColumnFindAsset {
	AssetId = 0,
	RiskTrend,
	CurrentRisk,
	CurrentLOF,
	CurrentCOF,
	ConditionData,
	Grade,
	Menu,
}

export enum ColumnNoCDFindAsset {
	AssetId = 0,
	RiskTrend,
	CurrentRisk,
	CurrentLOF,
	CurrentCOF,
	Grade,
	Menu,
}

export const mapRowToCells = (row: RiskDetailsRow): string[] => {
	return [
		row?.ASSET_ID || '',
		row?.RISK_CHANGE == null || row?.RISK_CHANGE == undefined
			? ''
			: row?.RISK_CHANGE,
		row?.CURRENT_RISK?.toString(),
		row?.CURRENT_LOF?.toString(),
		row?.CURRENT_COF?.toString(),
		row?.CONDITION_DATA?.toString() ?? '',
		row?.GRADE?.toString(),
		'',
	];
};

export const mapRowToCellsNoCD = (row: RiskDetailsRow): string[] => {
	return [
		row?.ASSET_ID || '',
		row?.RISK_CHANGE == null || row?.RISK_CHANGE == undefined
			? ''
			: row?.RISK_CHANGE,
		row?.CURRENT_RISK?.toString(),
		row?.CURRENT_LOF?.toString(),
		row?.CURRENT_COF?.toString(),
		row?.GRADE?.toString(),
		row?.GRADE?.toString(),
	];
};

export const headerReactNodes = (
	assetType: string,
	showFindAsset: boolean,
	t?: TFunc,
): StylovyzeHeader[] => {
	const noCD = noConditionData(assetType);

	const rows: StylovyzeHeader[] = [
		{
			key: 'ASSET_ID',
			cell: t ? t('Asset ID') : 'Asset ID',
			maxWidth: '200px',
			align: 'left',
			sortable: true,
			padding: '0 10px',
		},
		{
			key: 'RISK_CHANGE',
			cell: t ? t('Risk Trend') : 'Risk Trend',
			width: 'auto',
			align: 'left',
			sortable: true,
			padding: '0 10px',
		},
		{
			key: 'CURRENT_RISK',
			cell: t ? t('Risk Score') : 'Risk Score',
			width: 'auto',
			align: 'left',
			sortable: true,
			padding: '0 10px',
		},
		{
			key: 'CURRENT_LOF',
			cell: t ? t('Total LoF') : 'Total LoF',
			width: 'auto',
			align: 'left',
			sortable: true,
			padding: '0 10px',
		},
		{
			key: 'CURRENT_COF',
			cell: t ? t('Total CoF') : 'Total CoF',
			width: 'auto',
			align: 'left',
			sortable: true,
			padding: '0 10px',
		},
	];

	if (!noCD) {
		rows.push({
			key: 'CONDITION_DATA',
			cell: t ? t('Condition Data') : 'Condition Data',
			width: 'auto',
			align: 'left',
			sortable: false,
			padding: '0 10px',
		});
	}

	rows.push({
		key: 'GRADE',
		cell: t ? t('Grade') : 'Grade',
		width: '150px',
		align: 'left',
		sortable: true,
		padding: '0 10px',
	});

	if (showFindAsset) {
		rows.push({
			key: 'MENU',
			cell: '',
			width: '68px',
			align: 'center',
			padding: '0 10px',
		});
	}

	return rows;
};

export const paginationDefault = (): Pagination => ({
	...paginationInitialState,
	sortKey: 'uploadDateTime',
	sortDescending: true,
});
